<template>
  <div id="map">
    <l-map
      :zoom="zoom"
      :minZoom="4"
      :center="center"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
      @update:bounds="boundsUpdated"
      :options="{attributionControl: false}"
      :maxBounds="[[-90, -180],[90, 180]]"
      :maxBoundsViscosity="1.0"
      id="map"
      ref="map"
    >
      <l-tile-layer :url="url" :noWrap="noWrap" ref="baseLayer"></l-tile-layer>
    </l-map>
  </div>
</template>

<style scoped>
#map {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>
<style>
.mycluster {
  text-align: center;
  font-weight: bold;
  border-radius: 100%;
  background-color: #ffd63a;
  border: 2px solid black;
}
.mycluster-small {
  width: 20px;
  height: 20px;
  font-size: 12px;
  line-height: 20px;
}
.mycluster-medium {
  width: 30px;
  height: 30px;
  font-size: 15px;
  line-height: 30px;
}
.mycluster-large {
  width: 50px;
  height: 50px;
  font-size: 18px;
}
.mycluster-extra-large {
  width: 60px;
  height: 60px;
  font-size: 25px;
}
.mapmarker {
  text-align: center;
  font-weight: bold;
  border-radius: 100%;
  background-color: #ffd63a;
  width: 15px;
  height: 15px;
  font-size: 12px;
  line-height: 15px;
  border: 2px solid black;
}
.mapmarker:hover {
  background-color: red !important;
}
</style>

<script>
import Vue from 'vue';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import { LMap, LTileLayer } from 'vue2-leaflet';

// import json from '../assets/gz_2010_us_040_00_500k.json';

export default {
  name: 'Map',
  components: {
    LMap,
    LTileLayer,
  },
  props: { activeMarkers: { default: () => [] } },
  data() {
    return {
      url: 'https://tiles.stadiamaps.com/tiles/stamen_toner-lite/{z}/{x}/{y}{r}.png',
      zoom: 5,
      center: [39, -95],
      bounds: null,
      noWrap: true,
      markers: null,
    };
  },
  methods: {
    onResize() {
      if (window.innerWidth > 1000) {
        Vue.nextTick(() => {
          this.$refs.map.mapObject.zoomControl.setPosition('bottomleft');
        });
      } else {
        Vue.nextTick(() => {
          this.$refs.map.mapObject.zoomControl.setPosition('topright');
        });
      }
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    initLocation() {
      this.markers = L.markerClusterGroup({
        iconCreateFunction(cluster) {
          let iconSize = L.point(20, 20);
          let clusterSize = 'small';
          if (cluster.getChildCount() > 5) {
            iconSize = L.point(30, 30);
            clusterSize = 'medium';
          } else if (cluster.getChildCount() > 10) {
            iconSize = L.point(50, 50);
            clusterSize = 'large';
          } else if (cluster.getChildCount() > 20) {
            iconSize = L.point(60, 60);
            clusterSize = 'extra-large';
          }
          return L.divIcon({
            html: `<div><div>${cluster.getChildCount()}</div></div>`,
            className: `mycluster mycluster-${clusterSize}`,
            iconSize,
          });
        },
      });

      this.activeMarkers.forEach((marker) => {
        if (marker.raidClass) {
          const className = marker.raidClass.replace(/[^a-zA-Z]/g, '').toLowerCase();
          marker.setIcon(L.divIcon({
            iconSize: L.point(15, 15),
            className: `mapmarker ${className}`,
            html: '<div><div>1</div></div',
          }));
          marker.getPopup().on('add', () => {
            const elements = document.getElementsByClassName(className);
            for (let i = 0; i < elements.length; i += 1) {
              elements[i].style.backgroundColor = 'red';
            }
          });
          marker.getPopup().on('remove', () => {
            const elements = document.getElementsByClassName(className);
            for (let i = 0; i < elements.length; i += 1) {
              elements[i].style.backgroundColor = '#ffd63a';
            }
          });
        } else {
          marker.setIcon(L.divIcon({
            iconSize: L.point(15, 15),
            className: 'mapmarker',
            html: '<div><div>1</div></div',
          }));
        }
        this.markers.addLayer(marker);
      });
      this.$refs.map.mapObject.addLayer(this.markers);
    },
    initMapMarkers() {
      const DefaultIcon = L.divIcon({
        iconSize: L.point(15, 15),
        className: 'mapmarker',
        html: '<div><div>1</div></div>',
      });

      L.Marker.prototype.options.icon = DefaultIcon;
    },
  },
  mounted() {
    this.onResize();
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  watch: {
    activeMarkers() {
      if (this.markers) {
        this.markers.clearLayers();
      }
      setTimeout(() => {
        this.initLocation();
      }, 100);
    },
  },
};
</script>
